<div>
    <span class="text-danger h3">Unauthorized Access!</span>
</div><br />
<div>
    <span>You have attempted to access a page that you are not authorized to view.</span><br /><br />
    <span>If you have any questions, please contact to site administrator.</span>
</div>